export default "__VITE_ASSET__kEus31eq__"